module.exports = __webpack_public_path__ + "img/pinfl__ko__id_doc.0eece30d.png";